module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "block_10"
  }, [_c('span', {
    staticClass: "text_1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('h1', {
    staticClass: "block_1",
    attrs: {
      "id": "toc_id_4"
    }
  }, [_c('span', {
    staticClass: "text_"
  }, [_vm._v("Acknowledgement")])]), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_3"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_11"
  }, [_c('span', {
    staticClass: "text_1"
  }, [_vm._v("I’d like to thank Austin Macauley Publishers for giving ")]), _c('span', {
    staticClass: "text_2"
  }, [_vm._v("Second Reality")]), _c('span', {
    staticClass: "text_1"
  }, [_vm._v(" a chance to be heard.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_12"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_11"
  }, [_c('span', {
    staticClass: "text_1"
  }, [_vm._v("I thank my husband, Matthew Harder, for loving me so genuinely that I did learn to love myself. This book would not be the same without your support and presence in my life.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_12"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_11"
  }, [_c('span', {
    staticClass: "text_1"
  }, [_vm._v("More broadly, I’d like to thank the people I’ve known. Every word I’ve written has been inspired by the impact of each moment I’ve lived. Even those who inflicted pain or sought to stifle my voice; I may not thank you for your choices, but I do thank you for teaching me further depths of sorrow that I did defeat.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_12"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_13"
  }, [_c('span', {
    staticClass: "text_1"
  }, [_vm._v("To my friends and lovers, the partners who taught me great depths of joy, laughter, and love… I thank you the most.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_6"
  }, [_c('span', {
    staticClass: "text_3"
  }, [_c('br', {
    staticClass: "calibre1",
    attrs: {
      "id": "calibre_pb_3"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2baadc4c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index_split_003.vue
// module id = 72
// module chunks = 0